module.exports = __webpack_public_path__ + "static/media/simple_req.63958e77.png";